import React from "react";
import { FaRecycle } from "react-icons/fa";

import SystematicRepechageBracket from "./SystematicRepechageBracket";

const SystematicRepechageBoard = ({
  repechageA,
  repechageB,
  onOpenCreate,
  onOpenEdit,
  onOpenScoreboard,
}) => {
  return (
    <div className="border-t border-slate-200 bg-slate-50 p-5 dark:border-white/10 dark:bg-slate-900/80">
      <div className="mb-5">
        <div className="inline-flex items-center gap-2 rounded-full bg-emerald-100 px-3 py-1 text-xs font-bold uppercase tracking-[0.16em] text-emerald-700 ring-1 ring-emerald-200 dark:bg-emerald-500/15 dark:text-emerald-100 dark:ring-emerald-400/30">
          <FaRecycle />
          Repêchage systématique
        </div>

        <h3 className="mt-3 text-xl font-bold text-slate-900 dark:text-white">
          Tableaux de repêchage
        </h3>

        <p className="mt-1 max-w-5xl text-sm text-slate-500 dark:text-slate-400">
          Tous les combattants qui perdent dans le tableau principal avant les
          demi-finales entrent dans un tableau de repêchage. Un combattant qui
          perd en repêchage est éliminé. Les gagnants des repêchages affrontent
          les perdants des demi-finales pour les places de 3e.
        </p>
      </div>

      <div className="space-y-6">
        <SystematicRepechageBracket
          title="Tableau de repêchage A"
          subtitle="Branche haute du tableau principal"
          accent="blue"
          data={repechageA}
          onOpenCreate={onOpenCreate}
          onOpenEdit={onOpenEdit}
          onOpenScoreboard={onOpenScoreboard}
        />

        <SystematicRepechageBracket
          title="Tableau de repêchage B"
          subtitle="Branche basse du tableau principal"
          accent="violet"
          data={repechageB}
          onOpenCreate={onOpenCreate}
          onOpenEdit={onOpenEdit}
          onOpenScoreboard={onOpenScoreboard}
        />
      </div>
    </div>
  );
};

export default SystematicRepechageBoard;